import { AnyError, ReduxAction } from '../interfaces'
import { NotificationsAttrKeys, NotificationsState, ReachMeNotification } from './interfaces'

// Action Types
export const SET_NOTIFICATIONS_COUNT = 'SET_NOTIFICATIONS_COUNT'
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const LOAD_MORE_NOTIFICATIONS = 'LOAD_MORE_NOTIFICATIONS'
export const REMOVE_NOTIFICATIONS = 'REMOVE_NOTIFICATIONS'
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ'
export const FETCHING_NOTIFICATIONS = 'FETCHING_NOTIFICATIONS'
export const ERROR_FETCHING_NOTIFICATIONS = 'ERROR_FETCHING_NOTIFICATIONS'
export const SET_NOTIFICATIONS_ATTRIBUTES = 'SET_NOTIFICATIONS_ATTRIBUTES'

const buildReduxAction = (type: string, data: any): ReduxAction => ({ type: type, payload: data })

// Actions
export const setNotificationsCount = (data: NotificationsState): ReduxAction =>
  buildReduxAction(SET_NOTIFICATIONS_COUNT, data)
export const addNotificationsAction = (data: ReachMeNotification[]): ReduxAction =>
  buildReduxAction(ADD_NOTIFICATIONS, data)
export const loadMoreNotificationsAction = (data: ReachMeNotification[]): ReduxAction =>
  buildReduxAction(LOAD_MORE_NOTIFICATIONS, data)
export const removeNotificationsAction = (data: string[]): ReduxAction => buildReduxAction(REMOVE_NOTIFICATIONS, data)
export const markNotificationReadAction = (data: string): ReduxAction => buildReduxAction(MARK_NOTIFICATION_READ, data)
export const setFetchingNotifications = (data: boolean): ReduxAction => buildReduxAction(FETCHING_NOTIFICATIONS, data)
export const setErrorFetchingNotifications = (data: AnyError | null): ReduxAction =>
  buildReduxAction(ERROR_FETCHING_NOTIFICATIONS, data)
export const setNotificationsAttributes = (data: NotificationsAttrKeys): ReduxAction =>
  buildReduxAction(SET_NOTIFICATIONS_ATTRIBUTES, data)
